
// 创建入口页
import CreateEntry from './react/createEntry';
import ConfigureStore from './react/configureStore';
// 常量工具
import KeyMirrorPlus from './helpers/keymirror';
import getBSGlobal from './helpers/getBSGlobal';
import getDecodeUrl from './helpers/getDecodeURL';
import getMiddlewares from './middleware';
// 中间件
import { CALL_FETCH } from './middleware/fetch';

let TalentCore =  {
	CreateEntry,
	ConfigureStore,
	KeyMirrorPlus,
	getBSGlobal,
	getDecodeUrl,
  CALL_FETCH,
  getMiddlewares,
}

export default TalentCore;

